// A score of 0 is a valid computed value; only non-numbers mean "no score".
export const hasScore = (value) => typeof value === 'number' && Number.isFinite(value);
